import { AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';

interface FacilitySettingsAuditLogs {
  name: string;
  changedOptions: string[];
  options: {
    name: string;
    property: string;
  }[];
}

export const facilitySettingsAuditLogs: FacilitySettingsAuditLogs[] = [
  {
    name: Tier2.DigitalSignage,
    changedOptions: [],
    options: [
      {
        name: Tier3.FeatureDigitalSignage,
        property: 'featureDigitalSignage',
      },
      {
        name: Tier3.Noticeboard,
        property: 'noticeboardEnabled',
      },
      {
        name: Tier3.DevicesColumn,
        property: 'isStaffHubDevicesColumnDigitalSignage',
      },
    ]
  },
  {
    name: Tier2.Concierge,
    changedOptions: [],
    options: [
      {
        name: Tier3.FamilyHubConcierge,
        property: 'additionalServicesEnabled',
      },
      {
        name: Tier3.MyHubConcierge,
        property: 'additionalServicesBookingsEnabled',
      },
      /*{
        name: Tier3.CanFamilyChargeToRoom,
        property: 'canFamilyChargeToRoom',
      },*/
      /*{
        name: Tier3.CanFamilyPayByCard,
        property: 'canFamilyPayByCard',
      },*/
      /*{
        name: Tier3.VendorsMarkServiceRequestsComplete,
        property: 'isVendorsCanCompleServiceRequests',
      },*/
    ]
  },
  {
    name: Tier2.Lifestyle,
    changedOptions: [],
    options: [
      /*{
        name: Tier3.Events,
        property: 'additionalServicesEventsEnabled',
      },*/
      {
        name: Tier3.FeatureLifestyle,
        property: 'featureLifestyle',
      },
      {
        name: Tier3.OptInLifestylePrograms,
        property: 'isOptInLifestylePrograms',
      },
      {
        name: Tier3.LifestylePrograms,
        property: 'lifestyleProgramsTileOnMyHubEnabled',
      },
      {
        name: Tier3.LocationBooking,
        property: 'isEnableRoomBooking',
      },
      {
        name: Tier3.ResidentEventPictures,
        property: 'isEnableResidentEventPictures',
      },
      {
        name: Tier3.WeeklyLifestyleEventsReport,
        property: 'isEnableWeeklyLifestyleEventsReport',
      },
      {
        name: Tier3.CreateWingsFromEvents,
        property: 'isCanCreateWings',
      },
      {
        name: Tier3.Calendar,
        property: 'isStaffHubCalendar',
      },
    ]
  },
  {
    name: Tier2.CommunicationManagement,
    changedOptions: [],
    options: [
      {
        name: Tier3.FamilyChats,
        property: 'familyChatEnabled',
      },
      {
        name: Tier3.ScheduledCalls,
        property: 'scheduledCallsEnabled',
      },
      {
        name: Tier3.TakePhoto,
        property: 'residentCanTakePhoto',
      },
      {
        name: Tier3.FamilyCanSeeNameOfStaff,
        property: 'canFamilySeeNameOfStaffSendingThemPictures',
      },
      {
        name: Tier3.StaffCanMessageFamily,
        property: 'canStaffMessageFamily',
      },
      {
        name: Tier3.EnableResidentChat,
        property: 'isResidentChat',
      },
      {
        name: Tier3.FamilyNewsletter,
        property: 'isEnableFamilyNewsletter',
      },
    ]
  },
  {
    name: Tier2.DailyCareUpdates,
    changedOptions: [],
    options: [
      {
        name: Tier3.FamilyHubCareTab,
        property: 'isEnableCareTab',
      },
      {
        name: Tier3.CareSummary,
        property: 'isCareSummary',
      },
      {
        name: Tier3.DailyPlan,
        property: 'isDailyPlan',
      },
      {
        name: Tier3.DailyCare,
        property: 'isDailyCare',
      },
      {
        name: Tier3.CarePlan,
        property: 'isCarePlan',
      },
      {
        name: Tier3.ShareToMCareNotes,
        property: 'isEnabledSharedNotesToMCare',
      },
    ]
  },
  {
    name: Tier2.Other,
    changedOptions: [],
    options: [
      {
        name: Tier3.ResidentReligiousAffiliation,
        property: 'isEnableResidentReligion',
      },
      {
        name: Tier3.MyHubFriendsFromOtherCommunities,
        property: 'isEnabledAddFriendsFromOtherCommunities',
      },
      {
        name: Tier3.StaffCanLoginOnBehalf,
        property: 'isStaffCanLogInOnBehalfOfResident',
      },
      {
        name: Tier3.CanInviteFamilyMembers,
        property: 'canInviteFamilyMembers',
      },
      {
        name: Tier3.ResidentConsentCheckbox,
        property: 'residentConsentCheckbox',
      },
      {
        name: Tier3.ResidentImport,
        property: 'isEnableCSVImportForResidents',
      },
      {
        name: Tier3.ResidentAddDelete,
        property: 'isEnableManuallyAddDeleteResidents',
      },
      {
        name: Tier3.ResidentCanInviteFamily,
        property: 'isEnableResidentsCanInviteFamily',
      },
      {
        name: Tier3.AdtAutomation,
        property: 'isEnableADT',
      },
      {
        name: Tier3.CommunityTileDirectoryListWing,
        property: 'isEnabledResidentWingVisibleForOtherResidents',
      },
      {
        name: Tier3.CommunityTileDirectoryDetailedInfo,
        property: 'isEnabledResidentInformationVisibleForOtherResidents',
      },
      {
        name: Tier3.StaffDirectory,
        property: 'isEnabledStaffDirectory',
      },
      {
        name: Tier3.ContentManagerGallery,
        property: 'isStaffHubContentManagerGallery',
      },
    ]
  },
  {
    name: Tier2.Surveys,
    changedOptions: [],
    options: [
      {
        name: Tier3.InsightsSurveys,
        property: 'isStaffHubSurveys',
      },
    ]
  },
  {
    name: Tier2.Maintenance,
    changedOptions: [],
    options: [
      {
        name: Tier3.Maintenance,
        property: 'maintenanceEnabled',
      }
    ]
  },
  {
    name: Tier2.Entertainment,
    changedOptions: [],
    options: [
      {
        name: Tier3.Media,
        property: 'mediaEnabled',
      },
      {
        name: Tier3.ContentManagerMediaLibrary,
        property: 'isStaffHubContentManagerMediaLibrary',
      },
    ]
  },
  {
    name: Tier2.Other,
    changedOptions: [],
    options: [
      {
        name: Tier3.DocumentsStaffHub,
        property: 'isStaffHubDocuments',
      },
      {
        name: Tier3.DocumentsMyHub,
        property: 'isEnabledDocumentsTile',
      },
      {
        name: Tier3.Kiosk,
        property: 'isEnabledKioskButton',
      },
      {
        name: Tier3.StaffApi,
        property: 'isEnabledStaffAPI',
      },
      {
        name: Tier3.ContactsApi,
        property: 'isEnabledContactsAPI',
      },
      {
        name: Tier3.MyHubFamilyTile,
        property: 'isEnabledMyHubFamilyTile',
      },
      {
        name: Tier3.EnableFamilyToResidentMessaging,
        property: 'isEnabledFamilyToResidentMessaging',
      },
      {
        name: Tier3.Intercom,
        property: 'isUsingIntercom',
      },
    ]
  }
];